import styled from 'styled-components';

export const StripDiv = styled.div`
	display: flex;
	justify-content: flex-start;
	align-items: center;
	gap: 0;
	padding-left:.35rem;
	label{
		font-size: 0.813rem;
		color: var(--subHeadingColor);
		transition-delay: 1s;
		font-family: Inter;
		position:relative;
	}
`;
export const LabelInfo = styled.div`
		font-size: 0.813rem;
		color: var(--subHeadingColor);
		transition-delay: 1s;
		font-family: Inter;
		font-weight:600;
		position:relative;
		padding-right: .15rem;
		display: flex;
		justify-content: flex-start;
		align-items: center;
		gap: .5rem;
		min-height:27px;
		// border-right: 1px solid #e4e4e4;
		padding-right: .65rem;
}
`;
export const ModalToggle = styled.div`{
	display: flex;
	margin-right: 10px;

	.switchButton .button{
	width: 35px;
	height: 22px;
}
		
.checkbox {
	position: relative;
	width: 100%;
	height: 100%;
	padding: 0;
	margin: 0;
	opacity: 0;
	cursor: pointer;
	z-index: 3;

	&:disabled{
		cursor: not-allowed;
	}
}

.knobs {
	z-index: 2;
	background: var(--toggleTrackColor);
	border-radius: 48px;
	border: 1.5px solid var(--toggleTrackColor);
}

.layer {
	width: 100%;
	transition: 0.3s ease all;
	z-index: 1;
}

#button-13 .knobs:before,
#button-13 .knobs:after,
#button-13 .knobs span {
	position: absolute;
	top: 1.5px;
	width:13px;
	height: 12px;
	font-size: 10px;
	font-weight: bold;
	text-align: center;
	line-height: 1;
	border-radius: 2px;
	transition: 0.3s ease all;
}
#button-13 .knobs span {
	top:2px
}

#button-13 .knobs:before,
#button-13 .knobs:after {
	color: #4e4e4e;
	z-index: 1;
}

#button-13 .knobs:before {
	content: "";
	left: 7px;
	visibility: hidden;
	display: none;
	top: 5px;
}
#button-13 .knobs:after{
content: "";
}

#button-13 .knobs span {
	width: 16px;
	height: 16px;
	left: 2px;
	background-color: var(--toggleThumbColor);
	z-index: 2;
	border-radius: 100%;
}

#button-13 .checkbox:checked + .knobs span {
	left: 15px;
	background-color: var(--toggleThumbColor);
}
#button-13 .checkbox:checked + .knobs:before {
	content: '';
	visibility: visible;
	display: block;
	color: #fff;
}

#button-13 .checkbox:checked + .knobs {
 background-color: var(--primary);
 border: 1.5px solid var(--primary);
}
#button-13 .checkbox:checked + .knobs:after {
	visibility: hidden;
	display: none;
}

#button-13 .checkbox~ .layer {
	background-color: var(--defaultBgColor);
	border-radius:48px ;
}
`;

export const MultiplePanelDelete = styled.div`
	display: flex;
  align-items: center;
  justify-content: flex-start;
  padding-left: 6px;
	gap: 5px;

	span{
		color: var(--textTitleColor);
    font-size: 0.813rem;
    white-space: nowrap;
    font-family: Inter;
    font-weight: 600;
	}
		
`;